import React, { useState } from "react";
import Modal from "../Modal";
import Button from "../Button";
import ModalErrorMessage from "../ModalErrorMessage";
import LoadingSpinner from "../Spinner";
import { CreateAgencyModalProps } from "./types";
import { ModalTitle, InputRow, Input, ActionsRow, ModalWrapper } from "./styles";

const CreateAgencyModal: React.FC<CreateAgencyModalProps> = ({
  open,
  onCancel,
  onCreate,
}) => {
  const [name, setName] = useState("");
  const [credits, setCredits] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!name.trim()) {
      setError("Please enter agency name.");
      return;
    }
    if (!credits.trim() || isNaN(Number(credits))) {
      setError("Please enter a valid number for total credits.");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const adminApi = (await import("../../api/admin/adminApi")).default;
      await adminApi.adminCreateAgency(name, Number(credits));
      setLoading(false);
      onCreate?.({ name, totalCredits: Number(credits) });
      setName("");
      setCredits("");
    } catch (e) {
      setLoading(false);
      setError("Failed to create agency.");
    }
  };

  if (!open) return null;

  return (
    <Modal onClick={onCancel}>
      <ModalWrapper>
        <ModalTitle>Create Agency</ModalTitle>
        {error && <ModalErrorMessage message={error} inline />}
        {loading ? (
          <div style={{ width: "100%", textAlign: "center", marginBottom: "70px" }}>
            <div style={{ marginBottom: 16, fontSize: 18, fontWeight: 500 }}>Creating agency...</div>
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div style={{ fontSize: 20, marginBottom: 8 }}>
              Enter agency details:
            </div>
            <InputRow>
              <Input
                type="text"
                placeholder="Agency name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </InputRow>
            <InputRow>
              <Input
                type="number"
                placeholder="Total credits"
                value={credits}
                onChange={e => setCredits(e.target.value)}
                min={0}
              />
            </InputRow>
            <ActionsRow>
              <Button 
                text="Cancel" 
                handleClick={onCancel} 
                $height="50px"
              />
              <Button 
                text="Create" 
                handleClick={handleCreate} 
                $height="50px"
                $secondary
              />
            </ActionsRow>
          </>
        )}
      </ModalWrapper>
    </Modal>
  );
};

export default CreateAgencyModal;
